import React from 'react';
// import UserShiftsPage from '../../components/shifts/UserShiftsPage'
import EmployeeShiftScheduler from '../../../components/shifts/EmployeeShiftScheduler'

const UserShifts = () => {
    return (
            <EmployeeShiftScheduler />
            //<UserShiftsPage />
    );
};

export default UserShifts;
